import { render } from "./Tile.vue?vue&type=template&id=9084f7f2"
import script from "./Tile.vue?vue&type=script&setup=true&lang=js"
export * from "./Tile.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Mask/Tiles/components/Tile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9084f7f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9084f7f2', __exports__)) {
    api.reload('9084f7f2', __exports__)
  }
  
  module.hot.accept("./Tile.vue?vue&type=template&id=9084f7f2", () => {
    api.rerender('9084f7f2', render)
  })

}


export default __exports__